import { createContext, useContext, useEffect, useState } from "react";
import { defaultPosts } from "../data/content";

const BlogContext = createContext(null);
const STORAGE_KEY = "ak-blog-posts";

function loadPosts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }
  return defaultPosts;
}

export function BlogProvider({ children }) {
  const [posts, setPosts] = useState(loadPosts);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(posts));
  }, [posts]);

  const slugify = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || `post-${Date.now()}`;

  const addPost = ({ title, excerpt, body, date }) => {
    const id = slugify(title);
    const post = {
      id,
      title,
      excerpt: excerpt || body.slice(0, 140) + "…",
      body,
      date: date || new Date().toISOString().slice(0, 10),
    };
    setPosts((prev) => [post, ...prev]);
    return post;
  };

  const updatePost = (id, updates) => {
    setPosts((prev) =>
      prev.map((p) => (p.id === id ? { ...p, ...updates } : p))
    );
  };

  const deletePost = (id) => {
    setPosts((prev) => prev.filter((p) => p.id !== id));
  };

  const getPost = (id) => posts.find((p) => p.id === id);

  return (
    <BlogContext.Provider
      value={{ posts, addPost, updatePost, deletePost, getPost }}
    >
      {children}
    </BlogContext.Provider>
  );
}

export function useBlog() {
  const ctx = useContext(BlogContext);
  if (!ctx) throw new Error("useBlog must be used within BlogProvider");
  return ctx;
}
